// extracted by mini-css-extract-plugin
module.exports = {"field":"LoginPage_field__26M0d","fields":"LoginPage_fields__sP1La","flexCol":"LoginPage_flexCol__3o7qk","img":"LoginPage_img__1o6BG"};